__webpack_require__.p = "/view-snapshot-counters/system-email-templates/";